module.exports = __webpack_public_path__ + "media/images/weather/10_night-a78d18e2a15fa878e37edcaf9c65499d.png";